import React, { useState } from 'react';
import Clock from 'assets/images/think/timer.svg';
import { launchTable } from 'components/ThinkTanks/modules/actions';
import Congratulations from 'components/CreationThinkSeed/components/Congratulations';
import {
  LaunchModal, Overlay, LaunchSubtitle, LaunchActionButton, LaunchNextButton, LaunchTitle,
} from './styles';

function Launch(props) {
  const {
    literals, history, data, user,
  } = props;
  const [launchModalStage, setLaunchModalStage] = useState('init');

  const handleSubmit = () => {
    launchTable(data.id, user.id).then(() => {
      history.push('/think');
    });
  };

  const congratulations = () => {
    setLaunchModalStage('congrats');
  };

  const launchSeed = () => {
    if (launchModalStage === 'congrats') {
      return (
        <LaunchModal>
          <div className='center_items'>
            <Congratulations literals={literals} />
            <LaunchTitle>
              {literals.congratsTitle}
            </LaunchTitle>
            <LaunchSubtitle>
              {literals.congratsText}
            </LaunchSubtitle>
            <div className='buttons'>
              <LaunchNextButton onClick={handleSubmit} cont>
                {literals.accept}
              </LaunchNextButton>
            </div>
          </div>
        </LaunchModal>
      );
    }

    return (
      <LaunchModal>
        <div className='close_button'>
          <i className='far fa-times-circle close_icon' onClick={props.close} />
        </div>
        <div className='center_items'>
          <img src={Clock} alt='' />
          <LaunchSubtitle>
            {literals.text}
          </LaunchSubtitle>
          <div className='buttons'>
            <LaunchActionButton color='#F63256' onClick={props.close}>
              {literals.no}
            </LaunchActionButton>
            <LaunchActionButton color='#2680EB' onClick={congratulations}>
              {literals.yes}
            </LaunchActionButton>
          </div>
        </div>
      </LaunchModal>
    );
  };

  return (
    <div>
      <Overlay />
      { launchSeed() }
    </div>
  );
}

export default Launch;



// WEBPACK FOOTER //
// ./src/components/Launch/components/index.jsx